import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: API.updateUser,
    onSuccess: async (newUser) => {
      await queryClient.setQueryData(USER_QUERY_KEYS.userData, newUser);
    },
  });
};
